import { isNil } from 'lodash'

export const isNullable = isNil
